module.exports = __webpack_public_path__ + "img/Technology-text.8546a231.jpg";